import React from 'react';
function Facebook({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        stroke="transparent"
        fill="currentColor"
        d="M12.8 9.6V8.16c0-.624.144-.96 1.152-.96H15.2V4.8h-1.92c-2.4 0-3.36 1.584-3.36 3.36V9.6H8V12h1.92v7.2h2.88V12h2.112l.288-2.4h-2.4z"
      />
    </svg>
  );
}

export default Facebook;
